import { useNavigate } from 'react-router-dom';

import { Logo } from '@/shared/components/Logo.js';

import { LoginForm } from '../components/LoginForm.js';

export function LoginPage(): JSX.Element {
  const navigate = useNavigate();
  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <div className="w-full max-w-md rounded-3xl bg-paper p-8 shadow-lg">
        <Logo variant="full" className="mx-auto mb-2 h-20 w-auto" />
        <p className="mb-6 text-center font-script text-lg text-brown-soft">
          Bon retour dans ta bibliothèque
        </p>
        <LoginForm onSuccess={() => navigate('/')} />
        <p className="mt-6 text-center text-xs text-brown-light">
          Inscriptions sur invitation uniquement — contacte un administrateur
          pour obtenir un compte.
        </p>
      </div>
    </main>
  );
}
